import { Avatar, PlanChip } from '../components/bits';
import { useClients } from '../data/store';
import { shortDate } from '../data/helpers';
import type { Stage } from '../data/types';

interface Props {
  onOpenClient: (id: string) => void;
}

const STAGES: { id: Stage; label: string }[] = [
  { id: 'lead', label: 'Lead' },
  { id: 'design', label: 'In design' },
  { id: 'review', label: 'In revisione' },
  { id: 'live', label: 'Online' },
];

export function PipelineView({ onOpenClient }: Props) {
  const clients = useClients();
  return (
    <div className="view">
      <div className="view-pad">
        <div className="rs-board">
          {STAGES.map((s) => {
            // A paused/suspended client isn't actively "Online" — keep the board's
            // live column in step with the "Siti online" KPI.
            const col = clients.filter((c) => c.stage === s.id && !(s.id === 'live' && c.status === 'paused'));
            return (
              <div className="rs-col" key={s.id}>
                <div className="rs-col-head">
                  <span className="rs-col-title">{s.label}</span>
                  <span className="rs-col-count">{col.length}</span>
                </div>
                {col.map((c) => (
                  <button type="button" className="rs-mini" key={c.id} onClick={() => onOpenClient(c.id)}>
                    <div className="rs-mini-top">
                      <Avatar client={c} size={30} />
                      <span style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                        <span className="rs-mini-name">{c.name}</span>
                        <span className="rs-mini-meta">{c.locality}</span>
                      </span>
                    </div>
                    <div className="rs-mini-foot">
                      <PlanChip plan={c.plan} />
                      <span className="rs-mini-meta">dal {shortDate(c.since)}</span>
                    </div>
                  </button>
                ))}
                {col.length === 0 && <div className="rs-muted" style={{ fontSize: 12.5, padding: '4px 6px' }}>Nessuno</div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
